import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'field-warnings[warnings]',
  templateUrl: './field-warnings.component.html',
  styleUrls: ['./field-warnings.component.scss']
})
export class FieldWarningsComponent implements OnInit {

  @Input() warnings: string[];

  constructor() { }

  ngOnInit(): void {
  }

}
